import { render, staticRenderFns } from "./product_management.vue?vue&type=template&id=ed7419d8&"
import script from "./product_management.vue?vue&type=script&lang=js&"
export * from "./product_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports